/**
 * 首页公告 / 热榜接口返回结构以服务端为准，此处做字段归一化，避免页面散落兼容逻辑。
 */

/**
 * @param {*} data - 接口业务数据（一般为 res.data，也可能是 list/整段字符串等）
 * @returns {string[]}
 */
export function normalizeNoticeLines(data) {
  if (data == null) return [];
  if (typeof data === 'string') {
    const s = data.trim();
    return s ? [s] : [];
  }
  if (typeof data === 'object' && !Array.isArray(data)) {
    const single =
      data.content ?? data.title ?? data.notice ?? data.text ?? data.body ?? '';
    if (typeof single === 'string' && single.trim()) {
      return [single.trim()];
    }
  }
  const raw = Array.isArray(data)
    ? data
    : data.list || data.rows || data.data || data.records || [];
  if (!Array.isArray(raw)) return [];
  return raw
    .map((item) => {
      if (typeof item === 'string') return item.trim();
      if (item && typeof item === 'object') {
        const line =
          item.content ??
          item.title ??
          item.notice ??
          item.name ??
          item.text ??
          '';
        return String(line).trim();
      }
      return '';
    })
    .filter(Boolean);
}

/**
 * @param {*} data - 接口 res.data
 * @returns {{ key: string, label: string }[]}
 */
export function normalizeLeaderboardTabs(data) {
  if (data == null) return [];
  const raw = Array.isArray(data) ? data : data.list || data.data || [];
  if (!Array.isArray(raw)) return [];
  return raw
    .map((item) => {
      const id = item.id ?? item.category_id;
      const label = item.name ?? item.title ?? item.label ?? '未命名';
      if (id === undefined || id === null || id === '') return null;
      return { key: String(id), label: String(label) };
    })
    .filter(Boolean);
}

/**
 * @param {*} data - 接口 res.data
 * @returns {{ rank: number, title: string, heat: string }[]}
 */
export function normalizeLeaderboardRows(data) {
  if (data == null) return [];
  const raw = Array.isArray(data) ? data : data.list || data.data || [];
  if (!Array.isArray(raw)) return [];
  return raw.map((item, idx) => {
    const rank = Number(item.rank ?? item.sort ?? idx + 1);
    const title =
      item.title ?? item.name ?? item.topic ?? item.content ?? '';
    const heatRaw = item.heat ?? item.hot ?? item.hot_value ?? item.score ?? item.views;
    const heat =
      heatRaw === undefined || heatRaw === null || heatRaw === '' ? '—' : String(heatRaw);
    return {
      rank: Number.isFinite(rank) ? rank : idx + 1,
      title: String(title),
      heat,
    };
  });
}
